import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { GzDialog, GzDialogEvents } from '../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../utils/translator.helper';

export class InformativeDialog {
  static open(text: string): GzDialogWebComponent {
    const footerContent = this.getProceedDialogButtons();
    const dialogConfigs: GzDialog = {
      headline: translateFn('Confirm'),
      bodyContent: translateFn(text),
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    this.attachDialogFooterListeners(footerContent, dialog);

    return dialog;
  }
  private static getProceedDialogButtons(proceedText = 'Confirm'): HTMLElement {
    const buttonsWrapper = document.createElement('div');

    buttonsWrapper.innerHTML = `
    <gz-button data-confirm='true'>
      ${translateFn(proceedText)}
    </gz-button>
    <gz-button type='outline' color='secondary' data-cancel='true'>
      ${translateFn('Cancel')}
    </gz-button>
  `;

    return buttonsWrapper;
  }

  private static attachDialogFooterListeners(
    element: HTMLElement,
    dialog: GzDialogWebComponent,
    confirmCallback?: Function,
    cancelCallback?: Function
  ): void {
    element.querySelector('[data-confirm]')?.addEventListener(
      'click',
      () => {
        if (confirmCallback) {
          confirmCallback();
          return;
        }

        dialog.emitDialogEvent(GzDialogEvents.CONFIRM);
      },
      { once: true }
    );

    element.querySelector('[data-cancel]')?.addEventListener(
      'click',
      () => {
        if (cancelCallback) {
          cancelCallback();
          return;
        }
        dialog.emitDialogEvent(GzDialogEvents.CANCEL);
      },
      { once: true }
    );
  }
}
